import React, { useCallback, useEffect, useMemo, useState } from 'react';
import RadioGroup from '@navi/web-ui/lib/components/RadioGroup';
import { IRenderingEngine, QuestionResponse, Option } from '../interfaces/index.type';
import { fetchSelectedQption } from '../actions';
import RenderingEngine from '.';
import { mapQuestionToRadioOptions } from '../utlis';
import { Typography } from '@navi/web-ui/lib/primitives';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import { toast } from '@primitives/Toast';

interface IRadioGroupOptions extends IRenderingEngine {
  handleSelectedChip?: (text: string, refId: string) => void;
  isFirstQuestion?: boolean;
}

const RadioGroupOptions: React.FC<IRadioGroupOptions> = props => {
  const {
    question,
    register,
    error,
    source,
    lan,
    customerId,
    toggleLoading,
    interactionType,
    setValue,
    handleSelectedChip,
    isFirstQuestion,
    unregister,
    clearErrors,
    ...remainingProps
  } = props;
  const [selectedRadio, setSelectedRadio] = useState<string>();
  const [moreQuestion, setmoreQuestion] = useState<Array<QuestionResponse>>([]);

  const { options, mandatory, referenceId, text } = question;

  useEffect(() => {
    if (options?.length) {
      const selectedRadio = options?.find(option => option?.metadata?.isDefault);
      isFirstQuestion &&
        typeof handleSelectedChip === 'function' &&
        handleSelectedChip(selectedRadio?.text ?? '', selectedRadio?.referenceId ?? '');
      if (selectedRadio?.referenceId) {
        setValue(`${source}_${referenceId}_option`, selectedRadio.referenceId);
        setSelectedRadio(selectedRadio?.referenceId as string);
        fetchSelectedQption(
          lan,
          customerId,
          selectedRadio?.referenceId,
          successCallback,
          interactionType,
          failureCallback
        );
      }
    }
    return () => {
      setValue(`${source}_${referenceId}_option`, undefined);
      unregister(`${source}_${referenceId}_option`);
      clearErrors(`${source}_${referenceId}_option`);
    };
  }, [options]);

  useEffect(() => {
    return () => {
      setValue(`${source}_${referenceId}_option`, undefined);
      unregister(`${source}_${referenceId}_option`);
      clearErrors(`${source}_${referenceId}_option`);
    };
  }, []);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedId = event?.target?.value;
    const selectedOption = options.find(option => option.referenceId === selectedId);
    isFirstQuestion &&
      typeof handleSelectedChip === 'function' &&
      handleSelectedChip(selectedOption?.text ?? '', selectedId);
    setSelectedRadio(selectedId);
    setValue(`${source}_${referenceId}_option`, selectedId);
    toggleLoading(true);
    fetchSelectedQption(
      lan,
      customerId,
      event.target.value,
      successCallback,
      interactionType,
      failureCallback
    );
  };

  const successCallback = useCallback((res: Array<QuestionResponse>) => {
    toggleLoading(false);
    setmoreQuestion(res);
  }, []);

  const failureCallback = useCallback(() => {
    toggleLoading(false);
    toast('something went wrong please try again', { type: 'error' });
  }, []);

  const moreOptions = useMemo(
    () =>
      moreQuestion.map(question => (
        <RenderingEngine
          key={`${source}_${selectedRadio}`}
          register={register}
          question={question}
          error={error}
          setValue={setValue}
          toggleLoading={toggleLoading}
          interactionType={interactionType}
          lan={lan}
          customerId={customerId}
          source={source}
          unregister={unregister}
          clearErrors={clearErrors}
          {...remainingProps}
        />
      )),
    [moreQuestion, props]
  );

  return (
    <div key={`${source}_${referenceId}_${text}_${selectedRadio}`}>
      <Typography variant={'p4'} as={'p'}>
        {text}{' '}
        {mandatory && (
          <sup>
            <RequiredIcon />
          </sup>
        )}
      </Typography>
      <RadioGroup
        options={mapQuestionToRadioOptions(options)}
        {...register(`${source}_${referenceId}_option`, {
          required: mandatory,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
            handleRadioChange(e);
          }
        })}
        value={selectedRadio}
      />
      {!isFirstQuestion && moreOptions}
    </div>
  );
};

export default RadioGroupOptions;
